import React from "react";
import { MapPin, Video, Truck } from "lucide-react";

const tgCities = [
  "Hyderabad", "Secunderabad", "Warangal", "Karimnagar", "Nizamabad",
  "Khammam", "Mahbubnagar", "Ramagundam", "Adilabad", "Suryapet",
];
const apCities = [
  "Visakhapatnam", "Vijayawada", "Guntur", "Tirupati", "Kurnool",
  "Nellore", "Rajahmundry", "Kakinada", "Anantapur", "Ongole",
];
const hydAreas = [
  "Madinaguda", "Miyapur", "Kukatpally", "KPHB", "Kondapur",
  "Madhapur", "Gachibowli", "Hitech City", "Jubilee Hills", "Banjara Hills",
  "Secunderabad", "Begumpet", "Ameerpet", "Punjagutta", "Nallagandla",
];

export const ServiceArea = () => {
  return (
    <section
      id="service-area"
      data-testid="service-area-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 rounded-full bg-[#EEF5EF] px-3.5 py-1.5 font-micro text-[#2E936F]">
              Our reach
            </span>
            <h2 className="mt-5 font-display text-4xl md:text-5xl leading-[1.05] text-[#242220]">
              Serving <em className="text-[#EB8771]">Hyderabad, Telangana</em> & Andhra Pradesh.
            </h2>
            <p className="mt-5 text-[#38312C] leading-relaxed">
              In‑clinic at Madinaguda, Hyderabad for patients from across the city and
              greater Telangana. For Andhra Pradesh and other districts, Dr. Shalini offers
              secure online video consultations — medication is delivered cold‑chain to your door.
            </p>

            <div className="mt-8 space-y-4">
              <div className="flex items-start gap-3 text-[15px]">
                <span className="h-10 w-10 rounded-2xl bg-[#EEF5EF] grid place-items-center shrink-0">
                  <MapPin className="h-4 w-4 text-[#2E936F]" strokeWidth={1.8} />
                </span>
                <div>
                  <p className="font-semibold text-[#242220]">In‑clinic · Hyderabad</p>
                  <p className="text-sm text-[#38312C]">Madinaguda, beside Mangalya Shopping Mall · Mon–Sat 11 AM – 3:30 PM</p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-[15px]">
                <span className="h-10 w-10 rounded-2xl bg-[#FCE9E2] grid place-items-center shrink-0">
                  <Video className="h-4 w-4 text-[#B84E38]" strokeWidth={1.8} />
                </span>
                <div>
                  <p className="font-semibold text-[#242220]">Online consultations</p>
                  <p className="text-sm text-[#38312C]">Available across Telangana, Andhra Pradesh, and anywhere in India.</p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-[15px]">
                <span className="h-10 w-10 rounded-2xl bg-[#E8EEF5] grid place-items-center shrink-0">
                  <Truck className="h-4 w-4 text-[#1E4D8A]" strokeWidth={1.8} />
                </span>
                <div>
                  <p className="font-semibold text-[#242220]">Cold‑chain medicine delivery</p>
                  <p className="text-sm text-[#38312C]">Genuine Mounjaro delivered to your door in Telangana & Andhra Pradesh.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="rounded-3xl border border-[#EAE7E1] p-7 bg-[#FAFAF7]">
              <p className="font-micro text-[#2E936F]">Hyderabad neighbourhoods</p>
              <p className="font-display text-xl mt-3 text-[#242220]">Patients visit from</p>
              <div className="mt-4 flex flex-wrap gap-1.5">
                {hydAreas.map((c) => (
                  <span
                    key={c}
                    className="inline-flex items-center rounded-full bg-white border border-[#EAE7E1] px-3 py-1 text-xs text-[#38312C]"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </div>
            <div className="rounded-3xl border border-[#EAE7E1] p-7 bg-[#FAFAF7]">
              <p className="font-micro text-[#B84E38]">Telangana</p>
              <p className="font-display text-xl mt-3 text-[#242220]">Online consultations in</p>
              <div className="mt-4 flex flex-wrap gap-1.5">
                {tgCities.map((c) => (
                  <span
                    key={c}
                    className="inline-flex items-center rounded-full bg-white border border-[#EAE7E1] px-3 py-1 text-xs text-[#38312C]"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </div>
            <div className="md:col-span-2 rounded-3xl border border-[#EAE7E1] p-7 bg-[#FAFAF7]">
              <p className="font-micro text-[#1E4D8A]">Andhra Pradesh</p>
              <p className="font-display text-xl mt-3 text-[#242220]">Online consultations in</p>
              <div className="mt-4 flex flex-wrap gap-1.5">
                {apCities.map((c) => (
                  <span
                    key={c}
                    className="inline-flex items-center rounded-full bg-white border border-[#EAE7E1] px-3 py-1 text-xs text-[#38312C]"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
